// SearchAndFilter.jsx - Reusable Component with Dynamic Sort Options
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTheme } from '../hooks/ThemeProvider';

const SearchAndFilter = ({
    searchValue,
    onSearchChange,
    sortBy,
    onSortChange,
    sortOptions = [],
    searchPlaceholder = 'Search...'
}) => {
    const { theme, toggle } = useTheme();
    return (
        <div className='search_Side'>
            <div className='inner_Search'>
                <img src='\assets\searchicon.svg' className='searchicon' alt='search' />
                <input
                    placeholder={searchPlaceholder}
                    type="text"
                    id="fname"
                    name="fname"
                    value={searchValue}
                    onChange={onSearchChange}
                />
            </div>
            <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Sort by <span>{sortBy.label}</span>
                    <div>
                         {
                theme === 'dark' ? <img className='dropsvg' src='\assets\droparrow.svg' /> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M3 4.5L6 7.5L9 4.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }

                       
                    </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {sortOptions.map((option, index) => (
                        <Dropdown.Item key={index} onClick={() => onSortChange(option)}>
                            <div className='drop_inside'>
                                <h5><span>{option.label}</span></h5>
                                {sortBy?.value === option.value && <img src='\assets\bluetick.svg' alt='selected' />}
                            </div>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default SearchAndFilter;